<div class="bloco">
  <h5 class="titulo">Possíveis Veículos</h5>
  <div *ngIf="naoEncontrouRegistros">
      <div class="row">
        <div class="col-auto item">Nenhum registro encontrado <i class="far fa-frown"></i></div>
      </div>
  </div>
  <div *ngIf="naoSolicitou">
      <div class="row">
          <div class="col-auto item">Você não solicitou essa consulta.</div>
        <!-- <div class="col-auto item"><button (click)="consultar()" [disabled]="consultando" class="btn btn-primary"><i class="fas fa-search"></i> Você não solicitou essa consulta. {{txtButtonConsultar}}</button></div> -->
      </div>
  </div>
  <div *ngIf="dados.veiculo">
    <div class="row">
        <table class="table table-sm ">
            <thead>
              <tr>
                <th>Fabricante</th>
                <th>Modelo</th>
                <th>Ano Modelo</th>
                <th>Valor médio FIPE</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of dados.veiculo">
                <td>{{row.fabricante}}</td>
                <td>{{row.modelo}}</td>
                <td>{{row.ano_modelo}}</td>
                <td>{{row.valor_fipe | currency:'BRL':true}}</td>
              </tr>
            </tbody>
          </table>
    </div>
  </div>
</div>
  
  